import FooterLogo from './footer-logo.vue';

export default FooterLogo;
